import { AnyAction } from '@reduxjs/toolkit';
import * as entityHandlers from '../../../modules/bin/entityHandlers';
import { GridOptions } from '../../../components/common/grid/gridOptions';
import ColumnModel from '../../../components/common/grid/columnModel';
import { Record } from '../../../modules/bin/utility';
import { CLEAR } from '../../../modules/general';
import update from '../../../helpers/update';
import { List as ListConstants } from '../../../constants';
import {
  franchiseColumnData,
  franchiseDefaultOrderBy,
  franchisesAvailableFiltersKeys,
  getFranchiseHubUrl
} from '../../../constants/franchise';
import {
  FRANCHISES_METADATA_REQUESTED,
  FRANCHISES_METADATA_SUCCESS,
  FRANCHISES_METADATA_FAILURE,
  FRANCHISES_LIST_DATA_REQUESTED,
  FRANCHISES_LIST_DATA_SUCCESS,
  FRANCHISES_LIST_DATA_FAILURE,
  FRANCHISES_CREATE_REQUESTED,
  FRANCHISES_CREATE_SUCCESS,
  FRANCHISES_CREATE_FAILURE,
  FRANCHISES_UPDATE_REQUESTED,
  FRANCHISES_UPDATE_SUCCESS,
  FRANCHISES_UPDATE_FAILURE,
  FRANCHISES_GET_REQUESTED,
  FRANCHISES_GET_SUCCESS,
  FRANCHISES_GET_FAILURE,
  FRANCHISES_MESSAGE_CLEAR
} from './franchiseTypes';

const initialState = {
  timestamp: new Date().getTime(),
  franchisesList: new GridOptions()
    .addColumns(
      franchiseColumnData.map((x) => {
        const column = new ColumnModel(x.path, x.header, x.customFormatter).setVisible(x.defaultVisible);
        // Make the name column clickable to the franchise hub
        if (x.path === 'name') {
          column.makeClickable(getFranchiseHubUrl as any, false, true);
        }
        return column;
      })
    )
    .orderBy(franchiseDefaultOrderBy.path, franchiseDefaultOrderBy.order)
    .addAvailableFiltersKeys(franchisesAvailableFiltersKeys)
    .getState(),
  record: Record.getDefaultState(),
  recordCreate: Record.getDefaultState(),
  recordEdit: Record.getDefaultState()
};

const franchiseReducer = (state = initialState, action: AnyAction) => {
  let newState = state;
  switch (action.type) {
    case CLEAR:
      newState = initialState;
      break;

    case FRANCHISES_METADATA_REQUESTED:
      newState = entityHandlers.metadataRequestedHandler(state, action);
      break;
    case FRANCHISES_METADATA_SUCCESS:
      newState = entityHandlers.metadataSuccessHandler(state, action);
      break;
    case FRANCHISES_LIST_DATA_REQUESTED:
      newState = entityHandlers.listDataRequestedHandler(state, action);
      break;
    case FRANCHISES_LIST_DATA_SUCCESS:
      newState = entityHandlers.listDataSuccessHandler(state, action);
      break;
    case FRANCHISES_LIST_DATA_FAILURE:
      newState = entityHandlers.listDataFailureHandler(state, action);
      break;
    case FRANCHISES_MESSAGE_CLEAR:
      newState = entityHandlers.crudClearErrorHandler(state, action.payload.key);
      break;
    case FRANCHISES_METADATA_FAILURE:
      newState = entityHandlers.listMetadataFailureHandler(state, action);
      break;
    case FRANCHISES_CREATE_REQUESTED:
    case FRANCHISES_UPDATE_REQUESTED:
    case FRANCHISES_GET_REQUESTED:
      newState = entityHandlers.getRecordRequestedHandler(state, action);
      break;
    case FRANCHISES_CREATE_SUCCESS:
    case FRANCHISES_UPDATE_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      newState = update.set(newState, 'franchisesList.ready', ListConstants.LIST_STATUS_NO_DATA);
      break;
    case FRANCHISES_GET_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      break;
    case FRANCHISES_CREATE_FAILURE:
    case FRANCHISES_UPDATE_FAILURE:
    case FRANCHISES_GET_FAILURE:
      newState = entityHandlers.crudErrorHandler(state, action);
      break;
    default:
      break;
  }
  return newState;
};

export default franchiseReducer;
